"use strict";

exports.__esModule = true;
var react_1 = require("react");
// Cached script statuses
var cachedScriptStatuses = {};
function getScriptNode(src) {
  var node = document.querySelector("script[src=\"".concat(src, "\"]"));
  var status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
  return {
    node: node,
    status: status
  };
}
function useScript(src, options) {
  var _a = (0, react_1.useState)(function () {
      var _a;
      if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
        return 'idle';
      }
      if (typeof window === 'undefined') {
        // SSR Handling - always return 'loading'
        return 'loading';
      }
      return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    }),
    status = _a[0],
    setStatus = _a[1];
  (0, react_1.useEffect)(function () {
    var _a, _b;
    if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
      return;
    }
    var cachedScriptStatus = cachedScriptStatuses[src];
    if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
      // If the script is already cached, set its status immediately
      setStatus(cachedScriptStatus);
      return;
    }
    // Fetch existing script element by src
    // It may have been added by another instance of this hook
    var script = getScriptNode(src);
    var scriptNode = script.node;
    if (!scriptNode) {
      // Create script element and add it to document body
      scriptNode = document.createElement('script');
      scriptNode.src = src;
      scriptNode.async = true;
      scriptNode.setAttribute('data-status', 'loading');
      document.body.appendChild(scriptNode);
      // Store status in attribute on script
      // This can be read by other instances of this hook
      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        var scriptStatus = event.type === 'load' ? 'ready' : 'error';
        scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
      };
      scriptNode.addEventListener('load', setAttributeFromEvent);
      scriptNode.addEventListener('error', setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
    }
    // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.
    var setStateFromEvent = function setStateFromEvent(event) {
      var newStatus = event.type === 'load' ? 'ready' : 'error';
      setStatus(newStatus);
      cachedScriptStatuses[src] = newStatus;
    };
    // Add event listeners
    scriptNode.addEventListener('load', setStateFromEvent);
    scriptNode.addEventListener('error', setStateFromEvent);
    // Remove event listeners on cleanup
    return function () {
      if (scriptNode) {
        scriptNode.removeEventListener('load', setStateFromEvent);
        scriptNode.removeEventListener('error', setStateFromEvent);
      }
      if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
        scriptNode.remove();
      }
    };
  }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
  return status;
}
exports["default"] = useScript;